module.exports = __webpack_public_path__ + "img/image152.0500a076.png";